/**
 * 핵심 서비스 페이지 번역 - 한국어
 */

export default {
  hero: {
    title: '핵심 서비스',
    subtitle: '기업 디지털 전환의 전 생애주기를 중심으로 전략 기획부터 일상 운영까지 엔드투엔드 서비스 포트폴리오를 제공합니다',
    imageAlt: '핵심 서비스 배경 이미지'
  },

  nav: {
    title: '서비스 카테고리'
  },

  portfolio: {
    eyebrow: 'Service Portfolio',
    introTitle: '엔드투엔드 서비스 포트폴리오',
    introDescription:
      '당사의 서비스 포트폴리오는 기업 디지털 전환의 전체 생애주기를 중심으로 설계되었습니다. 전략 기획, 구축, 지속 운영까지 여러 지역에서 일관되고 안정적이며 반복 가능한 IT 서비스 역량을 제공합니다.',
    serviceContentTitle: '서비스 내용',
    coreValueTitle: '핵심 가치',
    sections: [
      {
        id: 'digital-workplace',
        icon: 'fas fa-laptop',
        image: '/images/coreService/it-base.jpg',
        title: '디지털 워크플레이스',
        subtitle: '효율적이고 안정적인 통합 디지털 업무 경험',
        description:
          '임직원의 일상 업무와 협업 환경을 대상으로 엔드포인트, 계정, 협업 도구, 원격 근무, IT 자산 생애주기 관리를 지원하여 생산성과 서비스 경험을 높입니다.',
        serviceItems: [
          { icon: 'fas fa-desktop', text: '노트북, 데스크톱, 모바일 기기를 포함한 엔드포인트 및 업무 환경 지원' },
          { icon: 'fas fa-user-cog', text: '입퇴사 IT 지원(계정, 장비, 권한)' },
          { icon: 'fas fa-comments', text: '오피스 소프트웨어 및 협업 도구 지원' },
          { icon: 'fas fa-mobile-alt', text: '원격 근무 및 모바일 업무 지원' },
          { icon: 'fas fa-boxes', text: 'IT 자산 및 장비 생애주기 관리' },
          { icon: 'fas fa-chart-line', text: '디지털 업무 경험 최적화' }
        ],
        valueItems: [
          {
            icon: 'fas fa-globe-asia',
            title: '지역 통합 관리',
            points: ['통일된 SLA 기준', '중앙 집중형 서비스 관리', '지역 간 조율']
          },
          {
            icon: 'fas fa-building',
            title: '현지 제공 역량',
            points: ['각국 현지 엔지니어 네트워크', '신속 대응 체계', '현장과 원격의 연계 제공']
          },
          {
            icon: 'fas fa-language',
            title: '다국어 지원',
            points: ['중국어 / 영어 / 일본어 / 한국어', '문화 간 커뮤니케이션', '여러 지역에서 일관된 서비스 경험']
          }
        ]
      },
      {
        id: 'data-center-network',
        icon: 'fas fa-network-wired',
        image: '/images/coreService/base-operatoin.jpg',
        title: '데이터센터 및 네트워크 인프라 서비스',
        subtitle: '핵심 업무 시스템의 지속적이고 안정적인 운영 보장',
        description:
          '기업 네트워크, 사무실 네트워크, 매장 네트워크, 데이터센터 네트워크, 서버 및 스토리지 장비를 포괄하여 인프라 안정성과 비즈니스 연속성을 높입니다.',
        serviceItems: [
          { icon: 'fas fa-network-wired', text: '기업 네트워크 구축 및 유지보수(LAN / WAN / WiFi)' },
          { icon: 'fas fa-building', text: '매장 네트워크 및 사무실 네트워크 지원' },
          { icon: 'fas fa-tools', text: '스위치, 방화벽 등 네트워크 장비 설치 및 구성' },
          { icon: 'fas fa-search', text: '네트워크 장애 분석 및 성능 최적화' },
          { icon: 'fas fa-server', text: '데이터센터 네트워크 및 전산실 네트워크 관리' },
          { icon: 'fas fa-database', text: '서버 및 스토리지 장비 지원' },
          { icon: 'fas fa-clipboard-check', text: '데이터센터 운영 및 정기 점검' }
        ],
        valueItems: [
          {
            icon: 'fas fa-shield-alt',
            title: '안정성 향상',
            points: ['시스템 안정성과 가용성 향상', '핵심 시스템 장애 가능성 감소', '지속 가능한 운영 체계 구축']
          },
          {
            icon: 'fas fa-exclamation-triangle',
            title: '중단 리스크 감소',
            points: ['네트워크와 장비 문제를 빠르게 식별', '비즈니스 중단 시간 감소', '긴급 현장 대응 지원']
          },
          {
            icon: 'fas fa-business-time',
            title: '업무 연속성',
            points: ['핵심 업무의 지속 운영 지원', '본사, 매장, 데이터센터 포괄', '다지역 운영 관리에 적합']
          }
        ]
      },
      {
        id: 'retail-store-ops',
        icon: 'fas fa-store',
        image: '/images/industrySolution/industry-ticketAI.jpg',
        title: '리테일 매장 IT 운영 솔루션',
        subtitle: '다국가, 다매장 운영을 위한 표준화된 IT 지원',
        description:
          '리테일 체인과 지역 간 비즈니스를 대상으로 확장 가능하고 표준화된 매장 IT 운영 서비스를 제공하여 모든 매장의 안정적인 영업과 일관된 지원 경험을 보장합니다.',
        serviceItems: [
          { icon: 'fas fa-headset', text: '매장 일상 IT 운영 및 장애 대응' },
          { icon: 'fas fa-desktop', text: 'POS, 단말기 등 매장 장비 관리' },
          { icon: 'fas fa-network-wired', text: '매장 네트워크 및 시스템 지원' },
          { icon: 'fas fa-plus-circle', text: '신규 매장 IT 구축 및 오픈 지원' },
          { icon: 'fas fa-sync-alt', text: '매장 이전, 업그레이드, 폐점 지원' }
        ],
        valueItems: [
          {
            icon: 'fas fa-check-circle',
            title: '안정 영업',
            points: ['모든 매장의 안정 운영 보장', '장비와 네트워크 장애 영향 감소', '일상 운영 핵심 시나리오 포괄']
          },
          {
            icon: 'fas fa-bolt',
            title: '신속 대응',
            points: ['문제에 빠르게 대응', '영업 영향 최소화', '원격 진단과 현장 처리를 결합']
          },
          {
            icon: 'fas fa-sitemap',
            title: '통합 관리',
            points: ['지역 간 매장을 통합 관리', '표준화된 제공 프로세스', '서비스 품질을 중앙에서 추적']
          }
        ]
      },
      {
        id: 'cloud-operations',
        icon: 'fas fa-cloud',
        image: '/images/coreService/cloud-it.jpg',
        title: '클라우드 및 클라우드 운영 서비스',
        subtitle: '유연하고 효율적이며 지속적으로 최적화되는 클라우드 아키텍처',
        description:
          '퍼블릭 클라우드, 하이브리드 클라우드, 클라우드 자원 관리, 모니터링, 보안, 비용 최적화를 포함하여 클라우드 환경의 기획, 구축, 이전, 지속 운영을 지원합니다.',
        serviceItems: [
          { icon: 'fas fa-project-diagram', text: '클라우드 환경 구축 및 아키텍처 설계(퍼블릭 / 하이브리드)' },
          { icon: 'fas fa-cloud-upload-alt', text: '클라우드 이전 및 시스템 클라우드화' },
          { icon: 'fas fa-cogs', text: '클라우드 자원 관리 및 운영' },
          { icon: 'fas fa-shield-alt', text: '클라우드 모니터링 및 보안 관리' },
          { icon: 'fas fa-chart-pie', text: '클라우드 비용 최적화' }
        ],
        valueItems: [
          {
            icon: 'fas fa-expand-arrows-alt',
            title: '유연한 확장',
            points: ['IT 유연성과 확장성 향상', '피크 트래픽과 빠른 배포 지원', '멀티 클라우드와 하이브리드 환경에 적합']
          },
          {
            icon: 'fas fa-coins',
            title: '비용 최적화',
            points: ['자원 사용 최적화', '클라우드 비용 구조 관리', '자원 효율성을 지속적으로 추적']
          },
          {
            icon: 'fas fa-rocket',
            title: '빠른 변화 대응',
            points: ['빠르게 변화하는 비즈니스 요구 지원', '애플리케이션 출시 주기 단축', '클라우드 운영 투명성 향상']
          }
        ]
      },
      {
        id: 'digital-transformation',
        icon: 'fas fa-rocket',
        image: '/images/home/home-ai-empowerment.jpg',
        title: '디지털 전환 지원',
        subtitle: '전통적인 IT 운영에서 데이터 기반 관리로 전환',
        description:
          '회원 운영, 마케팅 자동화, 경량 서비스 진입점, 지식 축적, 오피스 자동화를 중심으로 IT 역량을 반복 가능하고 확장 가능한 디지털 운영 체계로 전환합니다.',
        serviceItems: [
          { icon: 'fas fa-users', text: 'CRM 소프트웨어 개발: 회원, 태그, 포인트, 혜택, 접점, 재구매 운영을 중심으로 C 엔드 회원 CRM 플랫폼 구축' },
          { icon: 'fas fa-bullhorn', text: 'MA 마케팅 자동화: 웹사이트, CRM, 이메일, 메시지 채널을 연결하여 리드 육성과 마케팅 여정 폐쇄 루프 형성' },
          { icon: 'fas fa-mobile-alt', text: '미니 프로그램: 예약, 수리 접수, 조회, 회원 서비스 등 시나리오에 맞춘 맞춤 개발' },
          { icon: 'fas fa-brain', text: 'AI 지식베이스: FAQ, SOP, 티켓 경험, 제품 자료를 통합하고 의미 검색과 권한 관리를 지원' },
          { icon: 'fas fa-robot', text: '오피스 에이전트: 이메일, 승인, 회의록, 업무 흐름, 지식 Q&A를 연결해 내부 협업 효율 향상' }
        ],
        valueItems: [
          {
            icon: 'fas fa-database',
            title: '데이터 기반',
            points: ['사람 중심 운영에서 데이터 중심 운영으로 전환', '운영 데이터 자산 축적', '관리 의사결정 품질 향상']
          },
          {
            icon: 'fas fa-tachometer-alt',
            title: '효율성과 투명성',
            points: ['운영 효율과 투명성 향상', '반복적인 수작업 감소', '프로세스와 서비스 진입점 통합']
          },
          {
            icon: 'fas fa-layer-group',
            title: '반복 가능한 확장',
            points: ['반복 가능한 IT 관리 체계 구축', '다지역 확산 지원', '지속적인 개선 체계 형성']
          }
        ]
      }
    ]
  }
}
